export default {
  AUTODASHBOARD: '/auto',
  LOGIN: '/',
  AMC_LOGIN: '/amc',
  SIGNUP: '/creation-de-compte',
  RECOVERY_PASSWORD: '/recuperation-mdp',
  ADD_CONTRACT: '/addContract',
  RECLAMATION: '/reclamation',
  FAQ: '/faq',
  NOTIFICATIONS: '/notifications',
  SERVICES: '/localisation-services',
  OFFRES: '/offres',
  AUTO_DETAILS: '/auto-contrat-details',
  RECOVERYLOGIN: '/recuperation-identifiant',
  CompensationServicesPage: '/auto/services-dindemnisation',
  DEVIS_PAGE: '/devis',
  MRHDASHBOARD: '/habitation',
  LEGAL_NOTICE: '/mentions-legales',
  SITEMAP: '/plan-du-site',
  LEXIQUE: '/lexique',
  CONTACT_US: '/contact',
  CONTACTS: '/contacts-utiles',
  COOKIES: '/cookies',
  MRH_DETAILS: '/habitation-contrat-details',
  EPARGN_DASHBOARD: '/epargne',
  EPARGN_DETAILS: '/epargne-contrat-details',
  MY_ACCOUNT: '/parametres-du-compte',
  AGENT: '/mon-agent',
  EPARGN_PENDING_VERIFICATION: '/epargne-id-en-cours-verification',
  AMC_PENDING_VERIFICATION: '/sante-id-en-cours-verification',
  AMC_DASHBOARD: '/sante',
  ASI_DASHBOARD: '/sante-internationale',
  ASI_DETAILS: '/sante-internationale-contrat-details',
  AMC_DETAILS: '/sante-contrat-details',
  STATUS: '/status',
};
